import React from 'react'
import CommonSurveySettingList from '../../../common/pages/secure/SurveySettingList'
import Config from '../../../Config'

class SurveySettingList extends CommonSurveySettingList {
  constructor (props) {
    super(props)
    this.apiUrl = Config.adminApiUrl.surveySetting
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'add':
        this.props.history.push('/admin/survey_setting/add')
        break
      case 'back':
        this.props.history.push('/admin/survey_setting_home')
        break
      default:
        break
    }
  }
  renderPageNavi () {
    return (
      <section className='nav-page'>
        <div className='container'>
          <div className='row'>
            <div className='span8'>
              <header className='page-header'>
                <h3>アンケート設定<br />
                  <small>こちらからアンケートを管理できます。</small>
                </h3>
              </header>
            </div>
            <div className='span8'>
              <ul className='nav nav-pills'>
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='新規のアンケートを登録' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('add')}>
                    <i className='icon-plus icon-large' /><br /><span>新規</span>
                  </a>
                </li>
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}>
                    <i className='icon-arrow-left icon-large' /><span>戻る</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default SurveySettingList



// WEBPACK FOOTER //
// ./src/admin/pages/secure/SurveySettingList.js